import Vue from 'vue'
import Router from 'vue-router'
import {store} from '../store'

const LoginView = () => import('@/views/auth/LoginView')
const BaseView = () => import('@/views/BaseView')

/**
 * Administration views
 *
 * @returns {Promise<*>|*}
 * @constructor
 */
const AdminBaseView = () => import('@/views/admin/AdminBaseView')

/**
 * User views
 *
 * @returns {Promise<*>|*}
 * @constructor
 */
const UsersIndexView = () => import('@/views/admin/users/IndexView')
const UsersListView = () => import('@/views/admin/users/ListView')
const UsersSaveView = () => import('@/views/admin/users/SaveView')

/**
 * Vat views
 * @returns {Promise<*>|*}
 * @constructor
 */
const VatsIndexView = () => import('@/views/admin/vats/IndexView')
const VatsListView = () => import('@/views/admin/vats/ListView')
const VatsSaveView = () => import('@/views/admin/vats/SaveView')

/**
 * Tables view
 */
const TablesIndexView = () => import('@/views/tables/IndexView')
const TablesListView = () => import('@/views/tables/ListView')

/**
 * Tables view
 */
const TableView = () => import('@/views/table/SaveView')

/**
 * Products views
 * @returns {Promise<*>|*}
 * @constructor
 */
const ProductsIndexView = () => import('@/views/admin/products/IndexView')
const ProductsListView = () => import('@/views/admin/products/ListView')
const ProductsSaveView = () => import('@/views/admin/products/SaveView')

/**
 * Products views
 * @returns {Promise<*>|*}
 * @constructor
 */
const CategoriesIndexView = () => import('@/views/admin/products/categories/IndexView')
const CategoriesListView = () => import('@/views/admin/products/categories/ListView')
const CategoriesSaveView = () => import('@/views/admin/products/categories/SaveView')

/**
 * Vat views
 * @returns {Promise<*>|*}
 * @constructor
 */
const VendorsIndexView = () => import('@/views/admin/vendors/IndexView')
const VendorsListView = () => import('@/views/admin/vendors/ListView')
const VendorsSaveView = () => import('@/views/admin/vendors/SaveView')

/**
 * Menus views
 * @returns {Promise<*>|*}
 * @constructor
 */
const MenusIndexView = () => import('@/views/admin/menus/IndexView')
const MenusListView = () => import('@/views/admin/menus/ListView')
const MenusSaveView = () => import('@/views/admin/menus/SaveView')

/**
 * Printers views
 * @returns {Promise<*>|*}
 * @constructor
 */
const PrintersIndexView = () => import('@/views/admin/printers/IndexView')
const PrintersListView = () => import('@/views/admin/printers/ListView')
const PrintersSaveView = () => import('@/views/admin/printers/SaveView')

/**
 * Tables plans views
 * @returns {Promise<*>|*}
 * @constructor
 */
const TablesPlanIndexView = () => import('@/views/admin/tables-plan/IndexView')
const TablesPlanListView = () => import('@/views/admin/tables-plan/ListView')
const TablesPlanSaveView = () => import('@/views/admin/tables-plan/SaveView')

/**
 * Stock views
 * @returns {Promise<*>|*}
 * @constructor
 */
const StockReportIndexView = () => import('@/views/admin/stock/IndexView')
const StockReportView = () => import('@/views/admin/stock/StockReport')

/**
 * Stock change views
 * @returns {Promise<*>|*}
 * @constructor
 */
const StockChangeIndexView = () => import('@/views/admin/stock-change/IndexView')
const StockChangeListView = () => import('@/views/admin/stock-change/ListView')
const StockChangeSaveView = () => import('@/views/admin/stock-change/SaveView')
const StockChangeDetailsView = () => import('@/views/admin/stock-change/DetailsView')

/**
 * Vendor Purchase views
 * @returns {Promise<*>|*}
 * @constructor
 */
const VendorPurchasesIndexView = () => import('@/views/admin/vendor-purchases/IndexView')
const VendorPurchasesListView = () => import('@/views/admin/vendor-purchases/ListView')
const VendorPurchasesSaveView = () => import('@/views/admin/vendor-purchases/SaveView')
const VendorPurchasesDetailsView = () => import('@/views/admin/vendor-purchases/DetailsView')

/**
 * Product units views
 * @returns {Promise<*>|*}
 * @constructor
 */
const ProductUnitsIndexView = () => import('@/views/admin/products/units/IndexView')
const ProductUnitsListView = () => import('@/views/admin/products/units/ListView')
const ProductUnitsSaveView = () => import('@/views/admin/products/units/SaveView')

/**
 * Configuration views
 * @returns {Promise<*>|*}
 * @constructor
 */
const ConfigIndexView = () => import('@/views/admin/config/IndexView')
const ConfigSaveView = () => import('@/views/admin/config/SaveView')

/**
 * Reports views
 * @returns {Promise<*>|*}
 * @constructor
 */
const ReportsIndexView = () => import('@/views/admin/reports/IndexView')
const ReportsListView = () => import('@/views/admin/reports/ListView')
const SalesReportView = () => import('@/views/admin/reports/SalesReport')
const StockChangeReportView = () => import('@/views/admin/reports/StockChangeReport')
const ClocktimeReportView = () => import('@/views/admin/reports/ClocktimeReport')
const ProductSalesReportView = () => import('@/views/admin/reports/ProductSalesReport')
const CashSalesReportView = () => import('@/views/admin/reports/CashSalesReport')
const EmployeesReportView = () => import('@/views/admin/reports/EmployeesReport')
const PurchasesReportView = () => import('@/views/admin/reports/PurchasesReport')
const ProductHourlySalesReportView = () => import('@/views/admin/reports/ProductHourlySalesReport')
const DeliveyReportView = () => import('@/views/admin/reports/DeliveryReport')
const CompoundItemsReportView = () => import('@/views/admin/reports/CompoundItemsReport')
const ClientSalesReportView = () => import('@/views/admin/reports/ClientSalesReport')
const DamagesReportView = () => import('@/views/admin/reports/DamagesReport')
const StartEndReportView = () => import('@/views/admin/reports/StartEndReport')
const SalesByCategoryReportView = () => import('@/views/admin/reports/SalesByCategoryReport')
const StaffReportView = () => import('@/views/admin/reports/StaffReport')
const SalesByMakerReport = () => import('@/views/admin/reports/SalesByMakerReport')
const DeliveryClientsReport = () => import('@/views/admin/reports/DeliveryClientsReport')
const ProductByCompoundItemsSalesReport = () => import('@/views/admin/reports/ProductsByCompoundItemsReport')
const SalesBook = () => import('@/views/admin/reports/SalesBookReport')
const PurchaseBook = () => import('@/views/admin/reports/PurchaseBookReport')
const StockThresholdReport = () => import('@/views/admin/reports/StockThresholdReport')
const RegularInvoiceReport = () => import('@/views/admin/reports/RegularInvoiceReport')
const ProductSalesIntervalReport = () => import('@/views/admin/reports/ProductSalesIntervalReport')
const ProductBetweenHoursSalesReport = () => import('@/views/admin/reports/ProductBetweenHoursSalesReport')
const PaymentMethodsReport = () => import('@/views/admin/reports/PaymentMethodsReport')
const VatSalesReport = () => import('@/views/admin/reports/VatSalesReport')
const PurchaseProductsReportView = () => import('@/views/admin/reports/PurchaseProductsReport')
const DuePaymentListView = () => import('@/views/admin/reports/DuePayments')
const ReturnedProductsReportView = () => import('@/views/admin/reports/ReturnedProductsReport')
const ReservationsReportView = () => import('@/views/admin/reports/ReservationsReport')
const TableTransfersReportView = () => import('@/views/admin/reports/TableTransfersReport')

/**
 * Banks views
 * @returns {Promise<*>|*}
 * @constructor
 */
const BanksIndexView = () => import('@/views/admin/banks/IndexView')
const BanksListView = () => import('@/views/admin/banks/ListView')
const BanksSaveView = () => import('@/views/admin/banks/SaveView')

/**
 * Handouts views
 * @returns {Promise<*>|*}
 * @constructor
 */
const HandoutsIndexView = () => import('@/views/admin/handouts/IndexView')
const HandoutsListView = () => import('@/views/admin/handouts/ListView')

/**
 * Product transactions views
 * @returns {Promise<*>|*}
 * @constructor
 */
const ProductTransactionsIndexView = () => import('@/views/admin/product-transactions/IndexView')
const ProductTransactions = () => import('@/views/admin/product-transactions/ProductTransactionsReport')
const ProductTransactionsPeriodReport = () => import('@/views/admin/product-transactions/ProductTransactionsPeriodReport')

/**
 * Points views
 * @returns {Promise<*>|*}
 * @constructor
 */
const PointsIndexView = () => import('@/views/admin/points/IndexView')
const PointsListView = () => import('@/views/admin/points/ListView')
const PointsSaveView = () => import('@/views/admin/points/SaveView')

/**
 * Vouchers views
 * @returns {Promise<*>|*}
 * @constructor
 */
const VouchersIndexView = () => import('@/views/admin/vouchers/IndexView')
const VouchersListView = () => import('@/views/admin/vouchers/ListView')
const VouchersSaveView = () => import('@/views/admin/vouchers/SaveView')

/**
 * Order view for non-restaurants
 * @returns {Promise<*>|*}
 * @constructor
 */
const BarcodeOrderView = () => import('@/views/barcode-order/OrderView')

/**
 * Clients views
 * @returns {Promise<*>|*}
 * @constructor
 */
const ClientsIndexView = () => import('@/views/admin/clients/IndexView')
const ClientsListView = () => import('@/views/admin/clients/ListView')
const ClientsSaveView = () => import('@/views/admin/clients/SaveView')

/**
 * Locations views
 * @returns {Promise<*>|*}
 * @constructor
 */
const LocationsIndexView = () => import('@/views/admin/locations/IndexView')
const LocationsListView = () => import('@/views/admin/locations/ListView')
// const LocationsSaveView = () => import('@/views/admin/locations/SaveView')

/**
 * Start End views
 * @returns {Promise<*>|*}
 * @constructor
 */
const StartEndIndexView = () => import('@/views/admin/start-end/IndexView')
const StartEndListView = () => import('@/views/admin/start-end/ListView')

/**
 * Stock reset views
 * @returns {Promise<*>|*}
 * @constructor
 */
const StockResetIndexView = () => import('@/views/admin/stock-reset/IndexView')
const StockResetListView = () => import('@/views/admin/stock-reset/ListView')
const StockResetSaveView = () => import('@/views/admin/stock-reset/SaveView')
const StockResetDetailsView = () => import('@/views/admin/stock-reset/DetailsView')

/**
 * Makers views
 * @returns {Promise<*>|*}
 * @constructor
 */
const MakersIndexView = () => import('@/views/admin/makers/IndexView')
const MakersListView = () => import('@/views/admin/makers/ListView')
const MakersSaveView = () => import('@/views/admin/makers/SaveView')

/**
 * Audit views
 * @returns {Promise<*>|*}
 * @constructor
 */
const AuditIndexView = () => import('@/views/admin/audit/IndexView')
const AuditListView = () => import('@/views/admin/audit/ListView')

/**
 * License view
 * @returns {Promise<*>|*}
 * @constructor
 */
const LicenseIndexView = () => import('@/views/admin/license/IndexView')
const LicenseListView = () => import('@/views/admin/license/ListView')

/**
 * Display view
 * @returns {Promise<*>|*}
 * @constructor
 */
const DisplayView = () => import('@/views/display/DisplayView')
const DisplayControllerView = () => import('@/views/display/DisplayControllerView')

/**
 * Displays views
 * @returns {Promise<*>|*}
 * @constructor
 */
const DisplaysIndexView = () => import('@/views/admin/displays/IndexView')
const DisplaysListView = () => import('@/views/admin/displays/ListView')
const DisplaysSaveView = () => import('@/views/admin/displays/SaveView')

/**
 * Invoice clients views
 * @returns {Promise<*>|*}
 * @constructor
 */
const InvoiceClientsIndexView = () => import('@/views/admin/invoice-clients/IndexView')
const InvoiceClientsListView = () => import('@/views/admin/invoice-clients/ListView')
const InvoiceClientsSaveView = () => import('@/views/admin/invoice-clients/SaveView')

/**
 * Invoice clients views
 * @returns {Promise<*>|*}
 * @constructor
 */
const PriceListIndexView = () => import('@/views/admin/price-list/IndexView')
const PriceListListView = () => import('@/views/admin/price-list/ListView')
const PriceListSaveView = () => import('@/views/admin/price-list/SaveView')

/**
 * Reservation clients views
 * @returns {Promise<*>|*}
 * @constructor
 */
const ReservationClientsIndexView = () => import('@/views/admin/reservation-clients/IndexView')
const ReservationClientsListView = () => import('@/views/admin/reservation-clients/ListView')
const ReservationClientsSaveView = () => import('@/views/admin/reservation-clients/SaveView')

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'LoginView',
      component: LoginView
    },
    {
      path: '/',
      component: BaseView,
      beforeEnter: (to, from, next) => {
        if (store.state.authStore.token.auth_token) {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        {
          path: '',
          component: AdminBaseView
        },
        {
          path: 'admin',
          name: 'Admin',
          component: AdminBaseView,
          children: [
            {
              path: 'users',
              component: UsersIndexView,
              children: [
                {
                  path: '',
                  name: 'UsersList',
                  component: UsersListView
                },
                {
                  path: 'create',
                  name: 'UsersCreate',
                  component: UsersSaveView
                },
                {
                  path: 'update/:id',
                  name: 'UsersUpdate',
                  component: UsersSaveView
                }
              ]
            },

            {
              path: 'vats',
              component: VatsIndexView,
              children: [
                {
                  path: '',
                  name: 'VatsList',
                  component: VatsListView
                },
                {
                  path: 'create',
                  name: 'VatsCreate',
                  component: VatsSaveView
                },
                {
                  path: 'update/:id',
                  name: 'VatsUpdate',
                  component: VatsSaveView
                }
              ]
            },

            {
              path: 'vendors',
              component: VendorsIndexView,
              children: [
                {
                  path: '',
                  name: 'VendorsList',
                  component: VendorsListView
                },
                {
                  path: 'create',
                  name: 'VendorsCreate',
                  component: VendorsSaveView
                },
                {
                  path: 'update/:id',
                  name: 'VendorsUpdate',
                  component: VendorsSaveView
                }
              ]
            },

            {
              path: 'menus',
              component: MenusIndexView,
              children: [
                {
                  path: '',
                  name: 'MenusList',
                  component: MenusListView
                },
                {
                  path: 'create/:id',
                  name: 'MenusCreate',
                  component: MenusSaveView
                },
                {
                  path: 'update/:id',
                  name: 'MenusUpdate',
                  component: MenusSaveView
                },

                {
                  path: 'products',
                  component: ProductsIndexView,
                  children: [
                    {
                      path: '',
                      name: 'ProductsList',
                      component: ProductsListView
                    },
                    {
                      path: 'create',
                      name: 'ProductsCreate',
                      component: ProductsSaveView
                    },
                    {
                      path: 'update/:id',
                      name: 'ProductsUpdate',
                      component: ProductsSaveView
                    }
                  ]
                },

                {
                  path: 'units',
                  component: ProductUnitsIndexView,
                  children: [
                    {
                      path: '',
                      name: 'ProductUnitsList',
                      component: ProductUnitsListView
                    },
                    {
                      path: 'create',
                      name: 'ProductUnitsCreate',
                      component: ProductUnitsSaveView
                    },
                    {
                      path: 'update/:id',
                      name: 'ProductUnitsUpdate',
                      component: ProductUnitsSaveView
                    }
                  ]
                },

                {
                  path: 'categories',
                  component: CategoriesIndexView,
                  children: [
                    {
                      path: '',
                      name: 'CategoriesList',
                      component: CategoriesListView
                    },
                    {
                      path: 'create',
                      name: 'CategoriesCreate',
                      component: CategoriesSaveView
                    },
                    {
                      path: 'update/:id',
                      name: 'CategoriesUpdate',
                      component: CategoriesSaveView
                    }
                  ]
                },

                {
                  path: 'price-lists',
                  component: PriceListIndexView,
                  children: [
                    {
                      path: '',
                      name: 'PriceListsList',
                      component: PriceListListView
                    },
                    {
                      path: 'create/:id',
                      name: 'PriceListCreate',
                      component: PriceListSaveView
                    },
                    {
                      path: 'update/:id',
                      name: 'PriceListUpdate',
                      component: PriceListSaveView
                    }
                  ]
                }
              ]
            },

            {
              path: 'printers',
              component: PrintersIndexView,
              children: [
                {
                  path: '',
                  name: 'PrintersList',
                  component: PrintersListView
                },
                {
                  path: 'create',
                  name: 'PrintersCreate',
                  component: PrintersSaveView
                },
                {
                  path: 'update/:id',
                  name: 'PrintersUpdate',
                  component: PrintersSaveView
                }
              ]
            },

            {
              path: 'displays',
              component: DisplaysIndexView,
              children: [
                {
                  path: '',
                  name: 'DisplaysList',
                  component: DisplaysListView
                },
                {
                  path: 'create',
                  name: 'DisplaysCreate',
                  component: DisplaysSaveView
                },
                {
                  path: 'update/:id',
                  name: 'DisplaysUpdate',
                  component: DisplaysSaveView
                }
              ]
            },

            {
              path: 'tables',
              component: TablesPlanIndexView,
              children: [
                {
                  path: '',
                  name: 'TablesPlanList',
                  component: TablesPlanListView
                },
                {
                  path: 'create/:id',
                  name: 'TablesPlanCreate',
                  component: TablesPlanSaveView
                },
                {
                  path: 'update/:id',
                  name: 'TablesPlanUpdate',
                  component: TablesPlanSaveView
                }
              ]
            },

            {
              path: 'stock',
              component: StockReportIndexView,
              children: [
                {
                  path: '',
                  name: 'StockReport',
                  component: StockReportView
                }
              ]
            },

            {
              path: 'product-transactions',
              component: ProductTransactionsIndexView,
              children: [
                {
                  path: '',
                  name: 'ProductTransactions',
                  component: ProductTransactions
                }
              ]
            },

            {
              path: 'product-transactions-period',
              component: ProductTransactionsIndexView,
              children: [
                {
                  path: '',
                  name: 'ProductTransactionsPeriodReport',
                  component: ProductTransactionsPeriodReport
                }
              ]
            },

            {
              path: 'stock-change',
              component: StockChangeIndexView,
              children: [
                {
                  path: '',
                  name: 'StockChangeList',
                  component: StockChangeListView
                },
                {
                  path: 'create/:id',
                  name: 'StockChangeCreate',
                  component: StockChangeSaveView
                },
                {
                  path: 'update/:id',
                  name: 'StockChangeUpdate',
                  component: StockChangeSaveView
                },
                {
                  path: 'details/:id',
                  name: 'StockChangeDetails',
                  component: StockChangeDetailsView
                }
              ]
            },

            {
              path: 'stock-reset',
              component: StockResetIndexView,
              children: [
                {
                  path: '',
                  name: 'StockResetList',
                  component: StockResetListView
                },
                {
                  path: 'create/:id',
                  name: 'StockResetCreate',
                  component: StockResetSaveView
                },
                {
                  path: 'update/:id',
                  name: 'StockResetUpdate',
                  component: StockResetSaveView
                },
                {
                  path: 'details/:id',
                  name: 'StockResetDetails',
                  component: StockResetDetailsView
                }
              ]
            },

            {
              path: 'vendor-purchases',
              component: VendorPurchasesIndexView,
              children: [
                {
                  path: '',
                  name: 'VendorPurchasesList',
                  component: VendorPurchasesListView
                },
                {
                  path: 'create/:id',
                  name: 'VendorPurchasesCreate',
                  component: VendorPurchasesSaveView
                },
                {
                  path: 'update/:id',
                  name: 'VendorPurchasesUpdate',
                  component: VendorPurchasesSaveView
                },
                {
                  path: 'details/:id',
                  name: 'VendorPurchasesDetails',
                  component: VendorPurchasesDetailsView
                }
              ]
            },

            {
              path: 'configuration',
              component: ConfigIndexView,
              children: [
                {
                  path: '',
                  name: 'ConfigSave',
                  component: ConfigSaveView
                }
              ]
            },

            {
              path: 'reports',
              component: ReportsIndexView,
              children: [
                {
                  path: '',
                  name: 'ReportsList',
                  component: ReportsListView
                },
                {
                  path: 'sales',
                  name: 'SalesReport',
                  component: SalesReportView
                },
                {
                  path: 'stockChange',
                  name: 'StockChangeReport',
                  component: StockChangeReportView
                },
                {
                  path: 'clocktime',
                  name: 'ClocktimeReport',
                  component: ClocktimeReportView
                },
                {
                  path: 'productSales',
                  name: 'ProductSalesReport',
                  component: ProductSalesReportView
                },
                {
                  path: 'cashSales',
                  name: 'CashSalesReport',
                  component: CashSalesReportView
                },
                {
                  path: 'employees',
                  name: 'EmployeesReport',
                  component: EmployeesReportView
                },
                {
                  path: 'purchases',
                  name: 'PurchasesReport',
                  component: PurchasesReportView
                },
                {
                  path: 'purchaseProducts',
                  name: 'PurchaseProductsReport',
                  component: PurchaseProductsReportView
                },
                {
                  path: 'productHourlySales',
                  name: 'ProductHourlySalesReport',
                  component: ProductHourlySalesReportView
                },
                {
                  path: 'delivery',
                  name: 'DeliveryReport',
                  component: DeliveyReportView
                },
                {
                  path: 'compoundItems',
                  name: 'CompoundItemsReport',
                  component: CompoundItemsReportView
                },
                {
                  path: 'sales/clients',
                  name: 'ClientsSalesReport',
                  component: ClientSalesReportView
                },
                {
                  path: 'damages',
                  name: 'DamagesReport',
                  component: DamagesReportView
                },
                {
                  path: 'startEnd',
                  name: 'startEndReport',
                  component: StartEndReportView
                },
                {
                  path: 'salesByCategory',
                  name: 'SalesByCategoryReport',
                  component: SalesByCategoryReportView
                },
                {
                  path: 'staff',
                  name: 'StaffReport',
                  component: StaffReportView
                },
                {
                  path: 'salesByMaker',
                  name: 'SalesByMakerReport',
                  component: SalesByMakerReport
                },
                {
                  path: 'deliveryClients',
                  name: 'DeliveryClientsReport',
                  component: DeliveryClientsReport
                },
                {
                  path: 'productByCompoundItemsSalesReport',
                  name: 'ProductByCompoundItemsSalesReport',
                  component: ProductByCompoundItemsSalesReport
                },
                {
                  path: 'salesBook',
                  name: 'SalesBookReport',
                  component: SalesBook
                },
                {
                  path: 'purchaseBook',
                  name: 'PurchaseBookReport',
                  component: PurchaseBook
                },
                {
                  path: 'stockThreshold',
                  name: 'StockThreshold',
                  component: StockThresholdReport
                },
                {
                  path: 'regularInvoiceReport',
                  name: 'RegularInvoiceReport',
                  component: RegularInvoiceReport
                },
                {
                  path: 'productIntervalReport',
                  name: 'ProductSalesIntervalReport',
                  component: ProductSalesIntervalReport
                },
                {
                  path: 'productBetweenHoursSalesReport',
                  name: 'ProductBetweenHoursSalesReport',
                  component: ProductBetweenHoursSalesReport
                },
                {
                  path: 'paymentMethodsReport',
                  name: 'PaymentMethodsReport',
                  component: PaymentMethodsReport
                },
                {
                  path: 'vatSalesReport',
                  name: 'VatSalesReport',
                  component: VatSalesReport
                },
                {
                  path: 'duePayments',
                  name: 'DuePaymentList',
                  component: DuePaymentListView
                },
                {
                  path: 'returnedProducts',
                  name: 'ReturnedProductsReport',
                  component: ReturnedProductsReportView
                },
                {
                  path: 'reservations',
                  name: 'ReservationsReport',
                  component: ReservationsReportView
                },
                {
                  path: 'tableTransfers',
                  name: 'TableTransfersReport',
                  component: TableTransfersReportView
                }
              ]
            },
            {
              path: 'banks',
              component: BanksIndexView,
              children: [
                {
                  path: '',
                  name: 'BanksList',
                  component: BanksListView
                },
                {
                  path: 'create/',
                  name: 'BanksCreate',
                  component: BanksSaveView
                },
                {
                  path: 'update/:id',
                  name: 'BanksUpdate',
                  component: BanksSaveView
                }
              ]
            },

            {
              path: 'handouts',
              component: HandoutsIndexView,
              children: [
                {
                  path: '',
                  name: 'HandoutsList',
                  component: HandoutsListView
                }
              ]
            },

            {
              path: 'points',
              component: PointsIndexView,
              children: [
                {
                  path: '',
                  name: 'PointsList',
                  component: PointsListView
                },
                {
                  path: 'create/',
                  name: 'PointsCreate',
                  component: PointsSaveView
                },
                {
                  path: 'update/:id',
                  name: 'PointsUpdate',
                  component: PointsSaveView
                }
              ]
            },

            {
              path: 'vouchers',
              component: VouchersIndexView,
              children: [
                {
                  path: '',
                  name: 'VouchersList',
                  component: VouchersListView
                },
                {
                  path: 'create/',
                  name: 'VouchersCreate',
                  component: VouchersSaveView
                },
                {
                  path: 'update/:id',
                  name: 'VouchersUpdate',
                  component: VouchersSaveView
                }
              ]
            },

            {
              path: 'clients',
              component: ClientsIndexView,
              children: [
                {
                  path: '',
                  name: 'ClientsList',
                  component: ClientsListView
                },
                {
                  path: 'create/',
                  name: 'ClientsCreate',
                  component: ClientsSaveView
                },
                {
                  path: 'update/:id',
                  name: 'ClientsUpdate',
                  component: ClientsSaveView
                }
              ]
            },

            {
              path: 'invoice-clients',
              component: InvoiceClientsIndexView,
              children: [
                {
                  path: '',
                  name: 'InvoiceClientsList',
                  component: InvoiceClientsListView
                },
                {
                  path: 'create/',
                  name: 'InvoiceClientsCreate',
                  component: InvoiceClientsSaveView
                },
                {
                  path: 'update/:id',
                  name: 'InvoiceClientsUpdate',
                  component: InvoiceClientsSaveView
                }
              ]
            },

            {
              path: 'reservation-clients',
              component: ReservationClientsIndexView,
              children: [
                {
                  path: '',
                  name: 'ReservationClientsList',
                  component: ReservationClientsListView
                },
                {
                  path: 'create/',
                  name: 'ReservationClientsCreate',
                  component: ReservationClientsSaveView
                },
                {
                  path: 'update/:id',
                  name: 'ReservationClientsUpdate',
                  component: ReservationClientsSaveView
                }
              ]
            },

            {
              path: 'locations',
              component: LocationsIndexView,
              children: [
                {
                  path: '',
                  name: 'LocationsList',
                  component: LocationsListView
                }
              ]
            },

            {
              path: 'start-end',
              component: StartEndIndexView,
              children: [
                {
                  path: '',
                  name: 'StartEndList',
                  component: StartEndListView
                }
              ]
            },

            {
              path: 'makers',
              component: MakersIndexView,
              children: [
                {
                  path: '',
                  name: 'MakersList',
                  component: MakersListView
                },
                {
                  path: 'create/',
                  name: 'MakersCreate',
                  component: MakersSaveView
                },
                {
                  path: 'update/:id',
                  name: 'MakersUpdate',
                  component: MakersSaveView
                }
              ]
            },

            {
              path: 'audit',
              component: AuditIndexView,
              children: [
                {
                  path: '',
                  name: 'AuditList',
                  component: AuditListView
                }
              ]
            },

            {
              path: 'license',
              component: LicenseIndexView,
              children: [
                {
                  path: '',
                  name: 'LicenseList',
                  component: LicenseListView
                }
              ]
            }
          ]
        },
        {
          path: 'tables',
          component: TablesIndexView,
          children: [
            {
              path: '',
              name: 'TablesListView',
              component: TablesListView
            }
          ]
        },
        {
          path: 'table/:id?',
          name: 'TableView',
          component: TableView
        },
        {
          path: 'barcode-order',
          name: 'BarcodeOrderView',
          component: BarcodeOrderView
        },
        {
          path: 'display',
          name: 'DisplayView',
          component: DisplayView
        },
        {
          path: 'display-controller',
          name: 'DisplayControllerView',
          component: DisplayControllerView
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js